<template>
  <div class="container">
    <div class="head">
      <img src="../assets/images/logo-cutout.png" alt="Logo cutout" />
      <h2>
        Xsensible <br />
        community
      </h2>
    </div>
    <p>Sign up for Xsensible community</p>
    <div class="form-container">
      <div class="steps hide-mobile">
        <router-link to="step-1" class="step">
          <img src="../assets/icons/check-shape.svg" alt="" />
          <p>Your info</p>
        </router-link>
        <div class="step">
          <img src="../assets/images/02.png" alt="" />
          <p>Add your Xsensible</p>
        </div>
      </div>
      <div class="steps-mobile only-mobile">
        <progress-ring class="ring" :progress="33">
          <span>02.</span>
        </progress-ring>
        <p>Add your Xsensible</p>
      </div>
      <div class="shoe-wrapper">
        <Shoe
          v-for="(shoe, i) in shoes"
          :key="i"
          :shoe="shoe"
          :is-selected="selectedShoe && selectedShoe.name === shoe.name"
          selectable
          @shoe-selected="selectedShoe = shoe"
          tabindex="0"
        />
      </div>
      <div class="end">
        <img src="../assets/icons/round-information-button.svg" alt="Info" />
        <p>
          Please choose the model you have bought, don’t mind the color. You can
          select this in the next step.
        </p>
      </div>
      <div class="end-btn-wrapper">
        <div>
          <button class="btn" @click="$router.push('step-1')">
            Previous
          </button>
        </div>
        <div>
          <button
            :disabled="!selectedShoe.name"
            @click="next"
            class="btn btn-primary"
            style="float: right;"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Shoe from '@/components/Shoe'
import { shoes } from '@/shoeMap'

export default {
  name: 'StepTwo',
  components: { Shoe },
  data() {
    return {
      shoes,
      selectedShoe: this.$store.state.shoe
    }
  },
  methods: {
    next() {
      if (this.selectedShoe) {
        this.$store.commit('setShoe', this.selectedShoe)
        this.$router.push('step-3')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.steps {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.shoe-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  margin-top: 20px;

  @media screen and (max-width: 1023px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 767px) {
    grid-template-columns: 1fr;
  }
}
</style>
